export const ParameterSlug_MarketplacePrice = "marketplace-price";

// The API has no dedicated flag to mark category parameters — we identify them by slug.
// This is the only way the API currently provides.
export const ParameterSlug_Category = "category";

// Shared across marketplace/collection/collectibles search composables — these are not
// real elastic filter parameters, so they are kept in the query string, not the filter path.
export const QUERY_FILTER_SLUG = "query";
export const SORT_FILTER_SLUG = "sort";
